module.exports = __webpack_public_path__ + "static/media/print_new.4e47ccc1.svg";